import { Helmet } from "react-helmet";

// Wrapper to fix type compatibility issues with react-helmet and React 18
const HeadHelmet = Helmet as any;

export default HeadHelmet;
